import { FileConstants } from '../../../constants/file-constants';

export class FileDownloadUtil {

    // downloads file
    downloadFile(filesrc, filename) {
        // constructing the blob 
        var fileString = filesrc.replace(FileConstants.REPLACE_STRING, '')
        // Converting and setting to createObjectURL
        var file = new Blob([this.convertBase64ToArrayBuffer(fileString)], { type: 'application/pdf' })
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL);
        var a = document.createElement('a');
        a.href = fileURL;
        a.target = '_blank';
        a.download = filename + '.pdf';
        document.body.appendChild(a);
        a.click();
    }

    // converts to binary
    convertBase64ToArrayBuffer(base64) {
        var binary_string = base64.replace(/\\n/g, '');
        binary_string = window.atob(base64);
        var len = binary_string.length;
        var bytes = new Uint8Array(len);
        for (var i = 0; i < len; i++) {
            bytes[i] = binary_string.charCodeAt(i);
        }
        return bytes.buffer;
    }

}
